import { CognitoIdentityCredentials } from 'aws-sdk'
import * as AWS from '../constants/aws.constant'
import { CognitoUserSession } from 'amazon-cognito-identity-js'

export const signin = (data: { username: string; password: string }) => {
  return new Promise((resolve, reject) => {
    let cognitoUser = AWS.cognitoUser(data.username)
    const authConfig = {
      onSuccess: result => {
        // FIXME: なぜかない
        return resolve(result)
      },
      onFailure: (e: any) => {
        return reject(e)
      },
      newPasswordRequired(userAttributes: any, requiredAttributes: any) {
        cognitoUser.completeNewPasswordChallenge(data.password, {}, authConfig)
      },
    }
    cognitoUser.authenticateUser(
      AWS.authenticationDetail(data.username, data.password),
      authConfig
    )
  })
}

export const signOut = () => {
  return new Promise(resolve => {
    let userPool = AWS.userPool()
    let cognitoUser = userPool.getCurrentUser()
    if (cognitoUser != null) cognitoUser.signOut()
    return resolve()
  })
}

export const getSession = () => {
  return new Promise((resolve, reject) => {
    const userPool = AWS.userPool()
    const cognitoUser = userPool.getCurrentUser()
    if (cognitoUser) {
      cognitoUser.getSession((err: string, result: CognitoUserSession) => {
        let loginObject = {}
        loginObject[AWS.cognitoIdpURL] = result.getIdToken().getJwtToken()
        AWS.config.region = process.env.REACT_APP_AWS_REGION
        AWS.config.credentials = new CognitoIdentityCredentials({
          IdentityPoolId: String(process.env.REACT_APP_IDENTITY_POOL_ID),
          Logins: loginObject,
        })
        if (err) {
          reject(err)
        } else {
          resolve(result)
        }
      })
    } else {
      reject()
    }
  })
}



// WEBPACK FOOTER //
// ./src/services/auth.service.tsx